module.exports={
  "_args": [
    [
      "npm-registry-client@8.5.1",
      "C:\\Projects\\TBF\\Source"
    ]
  ],
  "_from": "npm-registry-client@8.5.1",
  "_id": "npm-registry-client@8.5.1",
  "_inBundle": true,
  "_integrity": "sha512-7rjGF2eA7hKDidGyEWmHTiKfXkbrcQAsGL/Rh4Rt3x3YNRNHhwaTzVJfW3aNvvlhg4G62VCluif0sLCb/i51Hg==",
  "_location": "/npm/npm-registry-client",
  "_phantomChildren": {
    "safe-buffer": "5.1.2"
  },
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "npm-registry-client@8.5.1",
    "name": "npm-registry-client",
    "escapedName": "npm-registry-client",
    "rawSpec": "8.5.1",
    "saveSpec": null,
    "fetchSpec": "8.5.1"
  },
  "_requiredBy": [
    "/npm"
  ],
  "_resolved": "https://registry.npmjs.org/npm-registry-client/-/npm-registry-client-8.5.1.tgz",
  "_spec": "8.5.1",
  "_where": "C:\\Projects\\TBF\\Source",
  "author": {
    "name": "Isaac Z. Schlueter",
    "email": "i@izs.me",
    "url": "http://blog.izs.me/"
  },
  "bugs": {
    "url": "https://github.com/npm/npm-registry-client/issues"
  },
  "dependencies": {
    "concat-stream": "^1.5.2",
    "graceful-fs": "^4.1.6",
    "normalize-package-data": "~1.0.1 || ^2.0.0",
    "npm-package-arg": "^3.0.0 || ^4.0.0 || ^5.0.0 || ^6.0.0",
    "npmlog": "2 || ^3.1.0 || ^4.0.0",
    "once": "^1.3.3",
    "request": "^2.74.0",
    "retry": "^0.10.0",
    "safe-buffer": "^5.1.1",
    "semver": "2 >=2.2.1 || 3.x || 4 || 5",
    "slide": "^1.1.3",
    "ssri": "^5.2.4"
  },
  "description": "Client for the npm registry",
  "devDependencies": {
    "negotiator": "^0.6.1",
    "nock": "^9.0.9",
    "readable-stream": "^2.1.5",
    "require-inject": "^1.4.0",
    "rimraf": "^2.5.4",
    "standard": "^11.0.0",
    "standard-version": "^4.3.0",
    "tap": "^11.1.2"
  },
  "files": [
    "lib",
    "index.js"
  ],
  "homepage": "https://github.com/npm/npm-registry-client#readme",
  "license": "ISC",
  "main": "index.js",
  "name": "npm-registry-client",
  "optionalDependencies": {
    "npmlog": "2 || ^3.1.0 || ^4.0.0"
  },
  "repository": {
    "url": "git+https://github.com/npm/npm-registry-client.git"
  },
  "scripts": {
    "postrelease": "npm publish && git push --follow-tags",
    "prerelease": "npm t",
    "pretest": "standard",
    "release": "standard-version -s",
    "test": "tap --nyc-arg=--all --coverage test/*.js"
  },
  "version": "8.5.1"
}
